import React, { useContext, useState } from "react";
import shareCapitalOptions from "config/shareCapitalOptions";
import { RadioGroup } from "@headlessui/react";
import RadioCards from "components/lib/Global/RadioCards";

import AllotmentOfShares from "./AllotmentOfShares";
import ForefeitureOfShares from "./ForefeitureOfShares";
import NoticeOfChangeOfName from "./NoticeOfChangeOfName";
import NoticeOfParticularsOfVariation from "./NoticeOfParticularsOfVariation";
import ReductionOfShareCapital from "./ReductionOfShareCapital";
import SharesBuyBack from "./SharesBuyBack";
import SharesConsolidation from "./SharesConsolidation";
import SharesRedemption from "./SharesRedemption";
import SharesSubdivision from "./SharesSubdivision";
import SharesTransfer from "./ShareTransfer";
import SurrenderOfShares from "./SurrenderOfShares";
import TakeoverOffer from "./TakeoverOffer";
import TransmissionOfShares from "./TransmissionOfShares";
import ShareCapitalContext from "context/ShareCapitalContext";
import { useSelector } from "react-redux";

const ShareCapital = ({
  shareCapitalOption,
  setshareCapitalOption,
  isRegistrar,
  isUploader,
}) => {
  const handleRadioChange = (option) => {
    setshareCapitalOption(option);
  };

  const filteredshareCapitalOptions = shareCapitalOptions.filter((option) => {
    if (isRegistrar || isUploader) {
      return true;
    } else {
      return (
        option.id === "SharesTransfer" || option.id === "SurrenderOfShares"
      );
    }
  });

  return (
    <ShareCapitalContext.Provider>
      <div className="text-sflPrimary">
        {!shareCapitalOption.id && (
          <RadioGroup onChange={handleRadioChange} className="my-4">
            <RadioGroup.Label className="text-base">
              <div>
                <h2 className="pb-4 font-semibold text-title5">
                  Share Capital
                </h2>
              </div>
            </RadioGroup.Label>
            <RadioCards
              options={filteredshareCapitalOptions}
              isInShareCapital={true}
            />
          </RadioGroup>
        )}
        {shareCapitalOption?.id && (
          <div>
            {shareCapitalOption.id === "AllotmentOfShares" && (
              <AllotmentOfShares />
            )}
            {shareCapitalOption.id === "ForefeitureOfShares" && (
              <ForefeitureOfShares />
            )}
            {shareCapitalOption.id === "NoticeOfChangeOfName" && (
              <NoticeOfChangeOfName />
            )}
            {shareCapitalOption.id === "NoticeOfParticularsOfVariation" && (
              <NoticeOfParticularsOfVariation />
            )}
            {shareCapitalOption.id === "ReductionOfShareCapital" && (
              <ReductionOfShareCapital />
            )}
            {shareCapitalOption.id === "SharesBuyBack" && <SharesBuyBack />}
            {shareCapitalOption.id === "SharesConsolidation" && (
              <SharesConsolidation />
            )}
            {shareCapitalOption.id === "SharesRedemption" && (
              <SharesRedemption />
            )}
            {shareCapitalOption.id === "SharesSubdivision" && (
              <SharesSubdivision />
            )}
            {shareCapitalOption.id === "SharesTransfer" && <SharesTransfer />}
            {shareCapitalOption.id === "SurrenderOfShares" && (
              <SurrenderOfShares />
            )}
            {shareCapitalOption.id === "TakeoverOffer" && <TakeoverOffer />}
            {shareCapitalOption.id === "TransmissionOfShares" && (
              <TransmissionOfShares />
            )}
          </div>
        )}
      </div>
    </ShareCapitalContext.Provider>
  );
};

export default ShareCapital;
